// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 {
  font-family: "Roboto";
  font-size: 22px;
  font-weight: normal;
}

.caixa_buscar {
  position: relative;
}

/* INPUT  */
.input_tabelaHistoricoDeLeitura {
  margin-top: 1.5em;
  background-color: var(--cor-roxoInput);
  border: none;
  width: 98.5%;
  height: 50px;
  border-radius: 8px;
  font-size: 1em;
}

.input_tabelaHistoricoDeLeitura::placeholder {
  font-family: "Roboto";
  font-weight: 400;
}

.input_tabelaHistoricoDeLeitura:focus {
  outline: none;
}

.input_tabelaHistoricoDeLeitura:hover {
  background-color: var(--cor-roxoClaro); 
}

.input_tabelaHistoricoDeLeitura[type="text"] {
  padding-left: 25px;
}

/* BTN PESQUISAR  */
.btn_pesquisar {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-25%);
  border: none;
  background-color: transparent;
  cursor: pointer;
  border-radius: 80px;
}

.btn_pesquisar:hover {
  background-color: var(--cor-roxoClaro);
}

/* TABELA  */
.container_historicoDeLeituraAluno {
  margin-top: 1.5em;
}`, "",{"version":3,"sources":["webpack://./src/Componets/TabelaHistoricoDeLeituraAluno.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,sCAAsC;EACtC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA,YAAY;AACZ;EACE,iBAAiB;AACnB","sourcesContent":["h2 {\n  font-family: \"Roboto\";\n  font-size: 22px;\n  font-weight: normal;\n}\n\n.caixa_buscar {\n  position: relative;\n}\n\n/* INPUT  */\n.input_tabelaHistoricoDeLeitura {\n  margin-top: 1.5em;\n  background-color: var(--cor-roxoInput);\n  border: none;\n  width: 98.5%;\n  height: 50px;\n  border-radius: 8px;\n  font-size: 1em;\n}\n\n.input_tabelaHistoricoDeLeitura::placeholder {\n  font-family: \"Roboto\";\n  font-weight: 400;\n}\n\n.input_tabelaHistoricoDeLeitura:focus {\n  outline: none;\n}\n\n.input_tabelaHistoricoDeLeitura:hover {\n  background-color: var(--cor-roxoClaro); \n}\n\n.input_tabelaHistoricoDeLeitura[type=\"text\"] {\n  padding-left: 25px;\n}\n\n/* BTN PESQUISAR  */\n.btn_pesquisar {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-25%);\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  border-radius: 80px;\n}\n\n.btn_pesquisar:hover {\n  background-color: var(--cor-roxoClaro);\n}\n\n/* TABELA  */\n.container_historicoDeLeituraAluno {\n  margin-top: 1.5em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
